export default {
  android:  require('@/assets/images/osPlaceholders/android_app.svg'),
  ios:  require('@/assets/images/osPlaceholders/ios_app.svg')
}
